import FileSaver from "file-saver"
import html2canvas from "html2canvas"

function saveSvgAsPng(svgWrapNode, fileName, options) {
  if (!svgWrapNode || !fileName) {
    return
  }
  html2canvas(svgWrapNode, {
    useCORS: true,
    scale: 4,
    ignoreElements: e => {
      if (e.contains(svgWrapNode) ||
        svgWrapNode.contains(e) ||
        e.tagName === "STYLE" ||
        e.tagName === "LINK" ||
        e.getAttribute("data-html2canvas") != null) {
        return false
      }
      return true
    },
    ...options
  }).then(canvas => {
    if(options?.isCopyImage) {
      canvas.toBlob((blob)=>{
        options?.callback(blob)
      })
    }else {
      options?.callback()
      let dataUrl = canvas.toDataURL("image/png")
      FileSaver.saveAs(dataUrl, fileName + ".png")
    }
  }).catch(err => {
    console.log("err", err)
  })
}

function getSvgPngBase64(svgWrapNode) {
  if (!svgWrapNode) {
    return
  }

  return new Promise((resolve, reject) => {
    html2canvas(svgWrapNode, {
      useCORS: true,
      scale: 4,
      ignoreElements: e => {
        if (e.contains(svgWrapNode) ||
          svgWrapNode.contains(e) ||
          e.tagName === "STYLE" ||
          e.tagName === "LINK" ||
          e.getAttribute("data-html2canvas") != null) {
          return false
        }
        return true
      },
    }).then(canvas => {
      let dataUrl = canvas.toDataURL("image/png")
      resolve(dataUrl);
    }).catch(err => {
      reject({
        code : -2,
        data : err,
      });
    })
  })
}

export { 
  saveSvgAsPng,
  getSvgPngBase64
}
